import { ExecutableAction, ExecutableActionParam } from '../utils/executable-action';
import { MessageCenterStateModel, MessageItem, MessageItemLevel, MessageItemType } from './message-center.model';

export class AddMessage implements ExecutableAction<MessageCenterStateModel> {
  static readonly type = '[Message Center] Add Message';

  static Error(level: MessageItemLevel, id: number, code: string, params?: any): AddMessage {
    return new AddMessage(MessageItemType.error, level, id, code, params);
  }

  static Warning(level: MessageItemLevel, id: number, code: string, params?: any): AddMessage {
    return new AddMessage(MessageItemType.warning, level, id, code, params);
  }

  static Info(level: MessageItemLevel, id: number, code: string, params?: any): AddMessage {
    return new AddMessage(MessageItemType.info, level, id, code, params);
  }

  static Queue(level: MessageItemLevel, id: number, code: string, params?: any): AddMessage {
    return new AddMessage(MessageItemType.queue, level, id, code, params);
  }

  static SectionError(id: number, code: string, params?: any): AddMessage {
    return new AddMessage(MessageItemType.error, MessageItemLevel.sections, id, code, params);
  }

  static SectionWarning(id: number, code: string, params?: any): AddMessage {
    return new AddMessage(MessageItemType.warning, MessageItemLevel.sections, id, code, params);
  }

  static SectionInfo(id: number, code: string, params?: any): AddMessage {
    return new AddMessage(MessageItemType.info, MessageItemLevel.sections, id, code, params);
  }

  static SectionQueue(id: number, code: string, params?: any): AddMessage {
    return new AddMessage(MessageItemType.queue, MessageItemLevel.sections, id, code, params);
  }

  static ColumnError(id: number, code: string, params?: any): AddMessage {
    return new AddMessage(MessageItemType.error, MessageItemLevel.columns, id, code, params);
  }

  static ColumnWarning(id: number, code: string, params?: any): AddMessage {
    return new AddMessage(MessageItemType.warning, MessageItemLevel.columns, id, code, params);
  }

  static ColumnInfo(id: number, code: string, params?: any): AddMessage {
    return new AddMessage(MessageItemType.info, MessageItemLevel.columns, id, code, params);
  }

  static ColumnQueue(id: number, code: string, params?: any): AddMessage {
    return new AddMessage(MessageItemType.queue, MessageItemLevel.columns, id, code, params);
  }

  static RecordError(id: number, code: string, params?: any): AddMessage {
    return new AddMessage(MessageItemType.error, MessageItemLevel.record, id, code, params);
  }

  static RecordWarning(id: number, code: string, params?: any): AddMessage {
    return new AddMessage(MessageItemType.warning, MessageItemLevel.record, id, code, params);
  }

  static RecordInfo(id: number, code: string, params?: any): AddMessage {
    return new AddMessage(MessageItemType.info, MessageItemLevel.record, id, code, params);
  }

  static RecordQueue(id: number, code: string, params?: any): AddMessage {
    return new AddMessage(MessageItemType.queue, MessageItemLevel.record, id, code, params);
  }

  constructor(
    public type: MessageItemType,
    public level: MessageItemLevel,
    public id: number,
    public code: string,
    public metadata?: any
  ) {}

  public execute(params: ExecutableActionParam<MessageItem[]>) {
    const state = params.ctx.getState();
    const newMessage = {
      type: this.type,
      level: this.level,
      id: this.id,
      code: this.code,
      params: this.metadata,
    };
    const alreadyExist = state.some(({ type, level, code, id, params: metadata }) => {
      const { isOverwrite = true, attrName } = metadata || {};
      return (
        type === this.type &&
        level === this.level &&
        code === this.code &&
        id === this.id &&
        attrName === this.metadata?.attrName &&
        isOverwrite
      );
    });
    const nextState = alreadyExist ? state : [...state, newMessage];
    params.ctx.setState(nextState);
  }
}
